import './index.css';

import React from 'react';
import classnames from 'classnames';

export default class Instruction extends React.Component {
  render() {
    return (
      <div
        className={classnames(
          'Instruction',
          this.props.visible && 'is-visible',
          this.props.wasVisible && 'was-visible',
        )}
      >
        <p>
          {this.props.children}
        </p>
      </div>
    );
  }
}

export class Container extends React.Component {
  render() {
    const {
      children,
      className,
      ...otherProps
    } = this.props;

    return (
      <div className={classnames('InstructionsContainer', className)} {...otherProps}>
        {children}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/shared/Instruction/index.js